import moment from 'moment-timezone'
export const timezones = moment.tz.names()
